<!--生产数据-->
<template>
	<div>
		<h3>生产数据</h3>
		<div class="content">
			<div class="item">
				<el-form ref="form" :model="form" inline :rules="rules" label-width="100px">
					<el-form-item label="生产单号" prop="Manufacture.makeId">
						<el-input  v-model="form.Manufacture.makeId" clearable></el-input>
					</el-form-item>
					<el-form-item label="批次编号" prop="Manufacture.batchNo">
						<el-input v-model="form.Manufacture.batchNo" clearable></el-input>
					</el-form-item>
					<el-form-item label="生产线" prop="Manufacture.WorkshopId">
						<el-select v-model="form.Manufacture.WorkshopId" clearable placeholder="请选择企业车间">
							<el-option
							v-for="item in productOrganizationData"
							:key="item.Workshopcode"
							:label="item.Workshopname"
							:value="item.Workshopcode">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="商品名称" prop="Productname">
						<el-input placeholder="全部商品" v-model="form.Productname" @focus="productfocus" clearable @clear="setProductNull"></el-input>
					</el-form-item>
					<el-form-item label="生产日期" prop="makeTime">
                        <el-date-picker
                        v-model="form.makeTime" clearable
                        type="daterange"
                        range-separator="-"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                        </el-date-picker>
					</el-form-item>
				</el-form>
				<span style="margin: 0 0 20px 100px;">
                    <el-button type="primary" @click="SelManufactureData">搜 索</el-button>
					<el-button @click="restForm" type="warning">重 置</el-button>
				</span>
			</div>
		</div>
        <div class="item">
			<el-table :data="tableData" highlight-current-row border>
				<el-table-column align="center" property="MakeId" label="生产单号"></el-table-column>
				<el-table-column align="center" property="WorkshopName" label="生产线"></el-table-column>
				<el-table-column align="center" property="BatchNo" label="批次号"></el-table-column>
				<el-table-column align="center" property="ProductName" label="商品名称"></el-table-column>
				<el-table-column align="center" property="Norms" label="商品规格"></el-table-column>
				<el-table-column align="center" property="TotalNums" label="计划数量"></el-table-column>
				<el-table-column align="center" property="RealityNum" label="实际生产量"></el-table-column>
				<el-table-column align="center" property="Status" label="订单状态"></el-table-column>
				<el-table-column align="center" property="Remark" label="详情"></el-table-column>
			</el-table>
			<el-pagination
			background
			@current-change="handleCurrentChange"
			layout="total,prev, pager, next,jumper"
			:total="pageNum"
			:page-size="10">
			</el-pagination>
		</div>
		<el-dialog title="选择商品" :visible.sync="productVisible" width="600px">
			<el-table :data="productData" highlight-current-row>
				<el-table-column align="center" width="80" property="DataId"></el-table-column>
				<el-table-column align="center" width="80" property="Productcode" label="商品编号"></el-table-column>
				<el-table-column align="center" width="200" property="Productname" label="商品名称"></el-table-column>
				<el-table-column align="center" width="200" label="操作">
					<template slot-scope="scope">
							<el-button type="primary" @click="confirm(scope)">选 择</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-dialog>
	</div>
</template>

<script>
export default {
	data(){
		return {
			form:{
				Manufacture:{
					makeId:'',
					ProductId:'',
					batchNo:'',
					WorkshopId:'',
				},
				makeTime:'',
				pageIndex:1,
				Productname:'',
				
			},
			pageNum:0,
			rules: {
        		makeTime:[
          			{ required: true, message: '请选择时间', trigger: 'change' }
        		]
			},
			productData:[],
			productOrganizationData:[],
			tableData: [],
			productVisible: false
		};
	},
	mounted : function(){
		var user = JSON.parse(sessionStorage.getItem('user'));
		this.GetProductOrganization(user.QyNum)
		this.getProduct(user.QyNum);
	},
	methods: {
		GetProductOrganization(CID){ //获取生产组织
			this.$axios({
				method: 'post',
				url:'/FW/WorkShop.ashx',
				params: {
					action:"query",
					CID:CID //企业id
				}
				}).then(res=>{
				if(res.Code==0){
					this.productOrganizationData=res.DataList;
				}else{
					this.$message({
					showClose: true,
					message: res.Msg,
					type: "warning"
					});
				}      
			})
		},
		getProduct(CID){
			this.$axios({
				method: 'post',
				url:'/FW/Product.ashx',
				params: {
					action:"query",
					cid:CID
				}
				}).then(res=>{
				if(res.Code==0){
					this.productData=res.DataList;
				}else{
					this.$message({
					showClose: true,
					message: res.Msg,
					type: "warning"
					});
				}      
			})
		},
		productfocus(){//获取商品
			this.productVisible=true;
		},
		confirm(scope){ //选中商品
			this.form.Manufacture.ProductId = scope.row.Productcode;
			this.form.Productname = scope.row.Productname;
			this.productVisible = false
		},
		setProductNull(){
			this.form.Manufacture.ProductId = '';
		},
		restForm(){//重置表单
			this.$nextTick(()=>{
				this.$refs['form'].resetFields()
			})
			this.form.Manufacture.ProductId = '';
		},

		SelManufactureData(){
			this.$refs['form'].validate((isValidate)=>{
				if(isValidate){
					var user = JSON.parse(sessionStorage.getItem('user'));
					this.$axios({
						method: 'post',
						url:'/FW/ManufactureData.ashx',
						params: {
							action:"SelManufactureData",
							CID:user.QyNum,
							manufacture:this.form.Manufacture,
							productForm:this.form.productForm,
							makeTime:this.form.makeTime,
							pageIndex:this.form.pageIndex
						}
						}).then(res=>{
						if(res.Code==0){
							this.tableData=res.Data.DataList;
							this.pageNum=res.Data.Total;
						}else{
							this.$message({
							showClose: true,
							message: res.Msg,
							type: "warning"
							});
						}      
					})
				}else{
					isValidate
				}
			})
		},
		handleCurrentChange(index){
			this.form.pageIndex=index;
			this.SelManufactureData()
		}
	}
}
</script>

<style scoped>
.title{
  text-align: left;
}
.btn{
	margin:0 0 10px 30px;
}
.el-select{
	display: inline;
}
</style>


// WEBPACK FOOTER //
// src/pages/manufactureData.vue